import getYearFromDate from "./getYearFromDate";

/**
 * Returns a string representing the period between the start and end years.
 *
 * @param {Date} startDate
 * @param {Date} endDate
 */
export default function getYearPeriod(startDate, endDate) {
  const startYear = startDate ? getYearFromDate(startDate) : null;
  const endYear = endDate ? getYearFromDate(endDate) : null;

  if (startYear && !endYear) {
    return `${startYear} - Present`;
  }

  if (startYear && endYear) {
    return `${startYear} - ${endYear}`;
  }

  if (endYear) {
    return `${endYear}`;
  }

  return "";
}
